import { fetchFactory } from '../../../utils/fetch'

export const getDashboardAlertTiles = () => fetchFactory('/dashboard/alert-tiles')

export const getDashboardGraphs = () => fetchFactory('/dashboard/graphs')
